import i18nCode from './i18n.js?raw';
import styles from './styles.css?raw';
import templateHtml from './widget-template.html?raw';
import widgetCode from './widget.js?raw';
import { installAppEmbed } from './app-embed.js';

// URL padrão do ícone resolvida relativamente ao arquivo atual (funciona em dev e build)
const DEFAULT_ICON_URL = new URL('./assets/icons/iturin.png', import.meta.url).toString()

;(function() {
  'use strict'

  if (window.IturanWidgetLoaded) return
  window.IturanWidgetLoaded = true

  function resolveBaseUrl() {
    try {
      // Preferir URL do módulo quando disponível (dev: type=module)
      try {
        if (typeof import.meta !== 'undefined' && import.meta.url) {
          const u = new URL(import.meta.url, window.location.href)
          const basePath = u.pathname.substring(0, u.pathname.lastIndexOf('/'))
          return `${u.origin}${basePath}`
        }
      } catch {}

      const scripts = document.getElementsByTagName('script')
      let current = document.currentScript || scripts[scripts.length - 1]
      if (!current || !current.src) {
        for (let i = scripts.length - 1; i >= 0; i--) {
          if (scripts[i].src && (scripts[i].src.includes('bundle') || scripts[i].src.includes('ituran-widget'))) {
            current = scripts[i]
            break
          }
        }
      }
      if (current) {
        const attrBase = current.getAttribute('data-base')
        if (attrBase) return attrBase.replace(/\/+$/, '')
        const u = new URL(current.src, window.location.href)
        const basePath = u.pathname.substring(0, u.pathname.lastIndexOf('/'))
        return `${u.origin}${basePath}`
      }
    } catch {}
    return window.location.origin
  }

  let BASE_URL = resolveBaseUrl()
  window.IturanBaseURL = BASE_URL

  function loadConfig() {
    return new Promise((resolve) => {
      // Se já existe uma configuração completa, não sobrescrever
      if (window.IturanConfig && window.IturanConfig.apiGatewayUrl && window.IturanConfig.channelIdentifier) {
        resolve();
        return;
      }

      // Tenta primeiro config.json, depois config.js, por fim defaults
      const tryJson = async () => {
        try {
          const resp = await fetch(`${BASE_URL}/config.json`, { cache: 'no-store' })
          if (resp.ok) {
            const json = await resp.json()
            window.IturanConfig = Object.assign({}, window.IturanConfig || {}, json)
            return true
          }
        } catch {}
        return false
      }

      const tryJs = () => new Promise((resolveJs) => {
        const s = document.createElement('script')
        s.src = `${BASE_URL}/config.js`
        s.onload = () => resolveJs(true)
        s.onerror = () => resolveJs(false)
        document.head.appendChild(s)
      })

      ;(async () => {
        const okJson = await tryJson()
        if (!okJson) {
          const okJs = await tryJs()
          if (!okJs) {
            window.IturanConfig = window.IturanConfig || {}
            window.IturanConfig.baseUrl = window.IturanConfig.baseUrl || BASE_URL
            window.IturanConfig.apiGatewayUrl = window.IturanConfig.apiGatewayUrl || 'http://localhost:8001/communication/livechat/'
            window.IturanConfig.language = window.IturanConfig.language || 'pt'
            window.IturanConfig.messages = window.IturanConfig.messages || {}
            window.IturanConfig.upload = window.IturanConfig.upload || { maxSize: 10 * 1024 * 1024 }
            window.IturanConfig.assets = window.IturanConfig.assets || {}
          }
        }
        resolve()
      })()
    })
  }

  function injectCSS() {
    const style = document.createElement('style')
    style.setAttribute('data-ituran', 'inline-styles')
    style.textContent = styles
    document.head.appendChild(style)
  }

  function injectTemplate() {
    const container = document.getElementById('ituran-widget')
    if (!container) {
      const newContainer = document.createElement('div')
      newContainer.id = 'ituran-widget'
      document.body.appendChild(newContainer)
      newContainer.innerHTML = templateHtml
    } else {
      container.innerHTML = templateHtml
    }
  }

  function executeWidgetCode() {
    // Executa o código do widget de forma segura
    try {
      // Executa o código i18n primeiro
      const i18nFunction = new Function(i18nCode)
      i18nFunction()

      // Executa o código do widget
      const widgetFunction = new Function(widgetCode)
      widgetFunction()
    } catch (error) {
      // Erro silencioso
    }
  }

  async function init() {
    await loadConfig()

    // Não sobrescreve BASE_URL via config. A resolução é baseada no próprio script
    // Ícone: se config tiver URL absoluta (http/https/data/blob), usa; senão usa asset gerenciado pelo Vite

    injectCSS()
    injectTemplate()

    try {
      const candidate = window.IturanConfig?.assets?.iconUrl
      const isAbsolute = typeof candidate === 'string' && (candidate.startsWith('http://') || candidate.startsWith('https://') || candidate.startsWith('data:') || candidate.startsWith('blob:'))
      const iconUrl = isAbsolute ? candidate : DEFAULT_ICON_URL
      const avatarImg = document.querySelector('.ituran-avatar')
      if (avatarImg) avatarImg.src = iconUrl
    } catch {}

    // App embed (mobile WebView): identity handoff, full-screen layout and the
    // native bridge. Read before the widget runs; inert on ordinary pages.
    installAppEmbed(window)

    // Executa a lógica do widget após o template estar presente no DOM
    executeWidgetCode()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()


